import React from 'react';
import DoneIcon from '@material-ui/icons/Done';
import Button from '@material-ui/core/Button';
import Label16 from '../../../theme/labels/Label16';
import makeStyles from '@material-ui/core/styles/makeStyles';
import createStyles from '@material-ui/core/styles/createStyles';
import CircularProgress from '@material-ui/core/CircularProgress';
import { useTranslation } from 'react-i18next';
import { StyledTextField, useButtonStyles } from './styles';
import { SignupTextFieldProps } from './SignupTextField';
import { GivelifyButton } from '@givelify/ui';

const marginTop = { marginTop: 16 };
export const OkButton: React.FC<{
    onSubmit: () => unknown;
    disabled?: boolean;
}> = ({ onSubmit, disabled }) => {
    const { t } = useTranslation();
    const { submit, mainButton } = useButtonStyles();
    return (
        <GivelifyButton
            text={t('signup.ok')}
            endIcon={<DoneIcon />}
            style={marginTop}
            className={`${submit} ${mainButton} fs-unmask`}
            variant="primary"
            disabled={disabled}
            onClick={onSubmit}
        />
    );
};

interface OkButtonWrapperProps {
    onSubmit?: TextFieldWrapperProps['onSubmit'];
    renderButton?: TextFieldWrapperProps['renderButton'];
    requestState?: TextFieldWrapperProps['requestState'];
}

export const OkButtonWrapper: React.FC<OkButtonWrapperProps> = ({
    onSubmit,
    renderButton,
    requestState,
}) => {
    const { buttonProgress, wrapper } = useButtonStyles();
    if (requestState?.type === 'REQUEST_START' && onSubmit) {
        return (
            <div className={wrapper}>
                <OkButton onSubmit={onSubmit} disabled={true} />
                <CircularProgress size={24} className={buttonProgress} />
            </div>
        );
    } else if (renderButton && onSubmit) {
        return <OkButton onSubmit={onSubmit} />;
    }
    return null;
};

const useStyles = makeStyles((theme) =>
    createStyles({
        skipStyles: {
            cursor: 'pointer',
            textAlign: 'right',
            position: 'absolute',
            right: 0,
            paddingTop: theme.spacing(3),
        },
    }),
);

interface TextFieldWrapperProps {
    renderButton: boolean;
    isError: boolean;
    value: string | undefined;
    isOptional?: true;
    className?: string;
    children: React.ReactNode;
    requestState?: SignupTextFieldProps['requestState'];
    onSubmit?: () => unknown;
    onSkip?: () => unknown;
}

const TextFieldWrapper: React.FC<TextFieldWrapperProps> = ({
    renderButton,
    isOptional,
    isError,
    className,
    children,
    requestState,
    onSkip,
    onSubmit,
}) => {
    const { t } = useTranslation();
    const { skipStyles } = useStyles();
    return (
        <>
            <StyledTextField className={className} isError={isError}>
                {children}
                {isOptional && onSkip && (
                    <Label16
                        isPrimary
                        isBold
                        onClick={onSkip}
                        className={skipStyles}
                    >
                        {t('labels.skip')}
                    </Label16>
                )}
            </StyledTextField>

            <OkButtonWrapper
                renderButton={renderButton}
                onSubmit={onSubmit}
                requestState={requestState}
            />
        </>
    );
};

export default TextFieldWrapper;
